//used for decode jwt
import * as XLSX from 'xlsx'

export const excelExport = {
    methods: {
        exportTableToExcel(tableID, filename = ''){
            var downloadLink;
            var dataType = 'application/vnd.ms-excel';
            var tableSelect = document.getElementById(tableID);
            var tableHTML = tableSelect.outerHTML.replace(/ /g, '%20');

            // Specify file name
            filename = filename?filename+'.xls':'excel_data.xls';

            // Create download link element
            downloadLink = document.createElement("a");

            document.body.appendChild(downloadLink);

            if(navigator.msSaveOrOpenBlob){
                var blob = new Blob(['\ufeff', tableHTML], {
                    type: dataType
                });
                navigator.msSaveOrOpenBlob( blob, filename);
            }else{
                // Create a link to the file
                downloadLink.href = 'data:' + dataType + ', ' + tableHTML;

                // Setting the file name
                downloadLink.download = filename;

                //triggering the function
                downloadLink.click();
            }
        },
        exportToExcelWithRowspanColspan(name) {
            const table = this.$refs.myTable;
            const wb = XLSX.utils.book_new();
            const ws = XLSX.utils.table_to_sheet(table, { raw: true });
      
            // Handling rowspan and colspan
            const range = XLSX.utils.decode_range(ws['!ref']);
            for (let R = range.s.r; R <= range.e.r; ++R) {
              for (let C = range.s.c; C <= range.e.c; ++C) {
                const cellAddress = { c: C, r: R };
                const cellRef = XLSX.utils.encode_cell(cellAddress);
                const cell = ws[cellRef];
      
                if (cell && cell.rowSpan > 1) {
                  // For cells with rowspan, merge the cells in the sheet
                  const mergeCell = {
                    s: { c: C, r: R },
                    e: { c: C, r: R + cell.rowSpan - 1 },
                  };
                  const mergeRef = XLSX.utils.encode_range(mergeCell);
                  ws[mergeRef] = { t: 's', v: cell.innerText };
                }
      
                if (cell && cell.colSpan > 1) {
                  // For cells with colspan, merge the cells in the sheet
                  const mergeCell = {
                    s: { c: C, r: R },
                    e: { c: C + cell.colSpan - 1, r: R },
                  };
                  const mergeRef = XLSX.utils.encode_range(mergeCell);
                  ws[mergeRef] = { t: 's', v: cell.innerText };
                }
              }
            }
      
      
            XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
      
            const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
      
            const blob = new Blob([wbout], { type: 'application/octet-stream' });
            const url = window.URL.createObjectURL(blob);
      
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = url;
            a.download = name+'.xlsx'; // Set the desired filename with .xlsx extension
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
          },
    }
}